// @ts-nocheck
import * as companyApi from '../api/companyApi';

export function saveCompanyKeyProviders(id, keyProviders) {
  return companyApi.saveCompanyKeyProviders(id, keyProviders);
}

export function getCompanyById(id) {
  return companyApi.getCompanyById(id);
}

export function loadCompanies(params) {
  return companyApi.getCompanies(params);
}

export function loadCompaniesWithOpenRequests(params) {
  return companyApi.getCompanies({
    ...params,
    filters: { ...params.filters, withOpenRequests: true },
  });
}

export function getRequestableCompanies(gameId, skuId) {
  return companyApi.getRequestableCompanies(gameId, skuId);
}

export function getStats(id) {
  return companyApi.getStats(id);
}

export function getStatsByDay(id) {
  return companyApi.getStatsByDay(id);
}

export function getAggregateStats(id, from, to) {
  return companyApi.getAggregateStats(id, from, to);
}

export function getAudit(id) {
  return companyApi.getAudit(id);
}

export function addAudit(id, comment) {
  return companyApi.addAudit(id, comment);
}

export function disableKeys(id) {
  return companyApi.disableKeys(id);
}

export function loadUsers({
  id,
  filters,
  _scopes,
  _sort,
  _order,
  _page,
  _limit,
}) {
  return companyApi.getUsers(
    id,
    filters,
    _scopes,
    _sort,
    _order,
    _page,
    _limit
  );
}

export function exportData(filters, scopes) {
  return companyApi.exportCompanyListData(filters, scopes);
}
